import Auth from '../auth';

class SignOutComponent {
  signOut() {
    Auth.signUserOut();
  }
}

export default {
    restrict: 'E',
    template: require("./sign-out.html"),
    controllerAs: 'vm',
    controller: SignOutComponent
};